module.exports = __webpack_public_path__ + "img/foregoer.1a569ad8.png";